export const formatAudienceQueryRawData = (rawData) => {
  const startDate = rawData.criteria.engagementStartDate || rawData.criteria.onboardStartDate
  const endDate = rawData.criteria.engagementEndDate || rawData.criteria.onboardEndDate

  return {
    channels: rawData.criteria.channels ? rawData.criteria.channels : [],
    gender: rawData.criteria.genders ? rawData.criteria.genders : [],
    language_operator: rawData.criteria.languages ? rawData.criteria.languages.languagesOp : null,
    dateFrom: startDate ? startDate.substring(0, 10) : '',
    dateTo: endDate ? endDate.substring(0, 10) : '',
    language: rawData.criteria.languages ? rawData.criteria.languages.languages : [],
    minAge: rawData.criteria.minAge ? rawData.criteria.minAge.toString() : '',
    referralStatus: rawData.criteria.referralStatus ? rawData.criteria.referralStatus : '',
    reminderRestriction: rawData.criteria.reminderRestriction ? rawData.criteria.reminderRestriction : '',
    onboardStatus: rawData.criteria.onboardStatus ? rawData.criteria.onboardStatus.split(',').map(x => Number(x)) : [],
    maxAge: rawData.criteria.maxAge ? rawData.criteria.maxAge.toString() : '',
    active_conversations_include: rawData.criteria.activeConversationsToInclude ? rawData.criteria.activeConversationsToInclude.split(',') : [],
    active_conversations_exclude: rawData.criteria.activeConversationsToExclude ? rawData.criteria.activeConversationsToExclude.split(',') : []
  }
}



// WEBPACK FOOTER //
// ./src/components/audience-builder/helpers.js